import { render, staticRenderFns } from "./secondStep.vue?vue&type=template&id=054040da&scoped=true"
import script from "./secondStep.vue?vue&type=script&lang=js"
export * from "./secondStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "054040da",
  null
  
)

export default component.exports